module.exports = __webpack_public_path__ + "img/round-silo.d1b40df5.svg";